module.exports = __webpack_public_path__ + "static/media/05-shot.f06444ad.png";